type HeaderKey = keyof typeof CsvColumnHeaders;

type CsvRow = {[K in HeaderKey]?: string};

const locationCsvTemplateFileName = 'LocationsCsvTemplate.csv';

const CsvColumnHeaders = {
  name: 'Name',
  category: 'Category',
  barcode: 'Barcode',
  length: 'Length',
  lengthUnit: 'Length Unit',
  width: 'Width',
  widthUnit: 'Width Unit',
  height: 'Height',
  heightUnit: 'Height Unit',
  sequenceId: 'Sequence ID',
  palletCapacity: 'Pallet Capacity',
  primaryPickLocation: 'Primary Pick Location',
  putAwayZone: 'Put Away Zone',
  temperature: 'Temperature'
};

const exampleRows: CsvRow[] = [
  {
    name: 'FS-A001-C22',
    category: 'floor_storage',
    barcode: 'DIDUJS39',
    length: '72',
    lengthUnit: 'in',
    width: '60.5',
    widthUnit: 'in',
    height: '60',
    heightUnit: 'in',
    sequenceId: '1',
    palletCapacity: '4',
    primaryPickLocation: 'TRUE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'RS-B012-C05',
    category: 'rack_storage',
    barcode: '38JSDI83',
    length: '72',
    lengthUnit: 'in',
    width: '60',
    widthUnit: 'in',
    height: '60.25',
    heightUnit: 'in',
    sequenceId: '2',
    palletCapacity: '4',
    primaryPickLocation: 'TRUE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'BIN-B102-PICK1',
    category: 'bin_storage',
    barcode: 'CKD9JD3G',
    length: '72',
    lengthUnit: 'in',
    width: '48',
    widthUnit: 'in',
    height: '24',
    heightUnit: 'in',
    sequenceId: '3',
    palletCapacity: '4',
    primaryPickLocation: 'FALSE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'OB-03',
    category: 'outbound_staging',
    barcode: 'K3I6J7DJ',
    length: '120',
    lengthUnit: 'in',
    width: '48',
    widthUnit: 'in',
    height: '24',
    heightUnit: 'in',
    sequenceId: '4',
    palletCapacity: '4',
    primaryPickLocation: 'FALSE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'IB-07',
    category: 'inbound_staging',
    barcode: 'V652M7QG',
    length: '120',
    lengthUnit: 'in',
    width: '48',
    widthUnit: 'in',
    height: '24',
    heightUnit: 'in',
    sequenceId: '5',
    palletCapacity: '4',
    primaryPickLocation: 'FALSE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'PS-947',
    category: 'pack_station',
    barcode: 'K3I6J7DJ',
    length: '120',
    lengthUnit: 'in',
    width: '48',
    widthUnit: 'in',
    height: '24',
    heightUnit: 'in',
    sequenceId: '6',
    palletCapacity: '4',
    primaryPickLocation: 'TRUE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'QA-01',
    category: 'quality_audit',
    barcode: 'CDF023CE',
    length: '72',
    lengthUnit: 'in',
    width: '48',
    widthUnit: 'in',
    height: '24',
    heightUnit: 'in',
    sequenceId: '7',
    palletCapacity: '4',
    primaryPickLocation: 'TRUE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'OSR-238',
    category: 'outbound_returns_staging',
    barcode: 'AR324BV9',
    length: '120',
    lengthUnit: 'in',
    width: '48',
    widthUnit: 'in',
    height: '24',
    heightUnit: 'in',
    sequenceId: '8',
    palletCapacity: '4',
    primaryPickLocation: 'FALSE',
    putAwayZone: 'ZONE-1',
    temperature: 'ambient'
  },
  {
    name: 'DOOR 2',
    category: 'dock',
    barcode: 'DOOR2',
    length: '',
    lengthUnit: '',
    width: '',
    widthUnit: '',
    height: '',
    heightUnit: '',
    sequenceId: '',
    palletCapacity: '',
    primaryPickLocation: 'FALSE',
    putAwayZone: '',
    temperature: 'ambient'
  }
];

function triggerBrowserDownload(content: string, filename: string) {
  const blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export const createCsv = (showZones: boolean, showPalletCapacity: boolean, showStorageClass: boolean) => {
  const excludedKeys = new Set<string>();
  if (!showZones) excludedKeys.add('putAwayZone');
  if (!showPalletCapacity) excludedKeys.add('palletCapacity');
  if (!showStorageClass) excludedKeys.add('temperature');

  const headers = Object.entries(CsvColumnHeaders)
    .filter(([key]) => !excludedKeys.has(key))
    .map(([key, header]) => ({key: key as HeaderKey, header}));

  const headerRow = headers.map((h) => h.header).join(',');
  const dataRows = exampleRows.map((row) => headers.map((h) => row[h.key] || '').join(','));

  const csvContent = [headerRow, ...dataRows].join('\n');
  triggerBrowserDownload(csvContent, locationCsvTemplateFileName);
};
